function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}.cls-2{fill:#fff}.cls-3{fill:none}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.086 26.557c.129.185 1.17 1.1 1.614 1.493.255.226.455.4.525.472a10.076 10.076 0 002.644.945 12.015 12.015 0 011.857.6.5.5 0 01-.226.946.517.517 0 01-.227-.053 12.48 12.48 0 00-1.668-.525 8.212 8.212 0 01-3.083-1.2c-.064-.063-.249-.225-.483-.433a9.65 9.65 0 01-1.858-1.818M1.584.992h26v4h-26zM21.084 11.491h-4.893a4.618 4.618 0 01.049.5h4.844a.5.5 0 000-1h-5.042a4.607 4.607 0 01.149.5zM21.084 15.491h-3.2l.5.5h2.7a.5.5 0 000-1h-3.695l.5.5zM7.859 19.123h7.13l-.5-.5h-6.63a.5.5 0 100 1h7.63l-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M21.607 19.273l.032-.031-.056-.056c.005.016.013.031.017.047s0 .027.007.04z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M20.635 19.492a1.71 1.71 0 00-1.409-1.249l-1.652-1.651-2.649-2.65a3.654 3.654 0 00.261-.745 3.548 3.548 0 00.093-.81A3.622 3.622 0 0014.2 9.809a3.686 3.686 0 00-3.4-.979 3.75 3.75 0 00-.74.251l1.213 1.212 1.212 1.213-.537 1.314-1.314.537-1.2-1.2-1.2-1.2a3.522 3.522 0 00-.221.693 3.619 3.619 0 001 3.323 3.674 3.674 0 002.6 1.068 3.729 3.729 0 00.737-.073 3.773 3.773 0 00.687-.211l2.663 2.664L17.282 20a1.734 1.734 0 00.055.374 1.707 1.707 0 003.3-.884zm-.723.669l-.01.04a.921.921 0 01-.649.649l-.04.01a.918.918 0 01-.887-.237l-.029-.029a.918.918 0 01-.238-.887l.011-.04a.917.917 0 01.649-.649l.04-.011a.918.918 0 01.887.238l.029.029a.918.918 0 01.237.887z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M25.327 24.734c-.641-1.655-2.344-2.5-3.135-4.083a1.624 1.624 0 01-.207-.739.807.807 0 01.8-.789 2.344 2.344 0 011.188.444 3.776 3.776 0 001.173.567 6.99 6.99 0 01.744.1 4.626 4.626 0 012.126 1.282c1.052 2.11.537 4.857 1.9 6.732"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M29.916 28.748a.5.5 0 01-.4-.206 8.276 8.276 0 01-1.206-3.835 9.644 9.644 0 00-.738-2.968 4.5 4.5 0 00-1.821-1.026 1.534 1.534 0 00-.325-.045 3.328 3.328 0 01-.37-.043 3.739 3.739 0 01-1.231-.564l-.109-.067a2.015 2.015 0 00-.907-.371h-.011a.31.31 0 00-.309.3 1.145 1.145 0 00.155.5 7.223 7.223 0 001.413 1.777 7.049 7.049 0 011.736 2.354.5.5 0 11-.932.362 6.2 6.2 0 00-1.516-2.016 8.109 8.109 0 01-1.6-2.024 2.048 2.048 0 01-.26-.974 1.308 1.308 0 011.289-1.278 2.821 2.821 0 011.46.517l.112.069a2.937 2.937 0 00.894.433 2.063 2.063 0 00.257.029 2.406 2.406 0 01.537.085c.02 0 1.981.642 2.429 1.536a10.564 10.564 0 01.834 3.273 7.427 7.427 0 001.023 3.389.5.5 0 01-.4.794z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M8.084 7.492h13"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.084 7.992h-13a.5.5 0 010-1h13a.5.5 0 010 1z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M7.859 22.942h13.128"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M20.987 23.441H7.859a.5.5 0 110-1h13.128a.5.5 0 010 1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M5.584 3.992v22h18v-5.227l-.228-.227.228.227V3.992h-18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M23.584 22.02v3.972h-18v-22h18v15.769l1-.367V2.992h-20v24h20v-3.885l-1-1.087z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M0 0h32v32H0z"
})));

var SvgRepairRegistermin = function SvgRepairRegistermin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRepairRegistermin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RepairRegister.min.4c54d9db.svg";
export { ForwardRef as ReactComponent };